// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"777229b8","453":"544d54ba","732":"e0758ad2","977":"ad83a7b1"}[chunkId] + ".chunk.js";
};